<script setup lang="ts">
import { useUxData } from '@/stores/ux-data';
import { useCharacterSourceFilter } from '@/composables/useCharacterSourceFilter';
import SourceFilterControl from '@/components/atoms/element-filters/SourceFilterControl.vue';

// Wraps SourceFilterControl with the has-a-character gate so every *Finder that offers the
// filter words and scopes it identically — the finders just drop this into their #filters slot.
// Source matches where an element was PUBLISHED, which is orthogonal to campaign setting, so it
// applies to every draft; only the world picker is gated on `!character.world`.
const ux = useUxData();
const { visible } = useCharacterSourceFilter();
</script>

<template>
  <SourceFilterControl
      v-if="visible"
      :label="ux.labels?.filters?.source?.chip ?? 'Source'"
      :placeholder="ux.labels?.filters?.source?.placeholder ?? 'World'"
  />
</template>
